import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/activity/zkoutop.png'
import _imports_1 from '@/assets/activity/newgoods.png'
import _imports_2 from '@/assets/activity/zhekou.png'
import _imports_3 from '@/assets/activity/biggrea.png'
import _imports_4 from '@/assets/activity/bigleftgrea.png'
import _imports_5 from '@/assets/activity/bigleftgrearight.png'


const _withScopeId = n => (_pushScopeId("data-v-3a56636a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "activity-box" }
const _hoisted_2 = {
  class: "activity-contents",
  style: {"overflow":"auto"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title-img",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "goods-swiper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "goods-swiper-title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_6 = { class: "goods-list" }
const _hoisted_7 = { class: "activity-goods" }
const _hoisted_8 = { class: "activity-goods-list" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "goods-swiper-title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_10 = { class: "goods-list" }
const _hoisted_11 = { class: "goods-list-item" }
const _hoisted_12 = {
  key: 0,
  class: "goods-list-text"
}
const _hoisted_13 = {
  key: 1,
  class: "goods-list-text"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "biggrea",
  src: _imports_3
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bigleftgrea",
  src: _imports_4
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bigleftgrearight",
  src: _imports_5
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_NewGoodsList = _resolveComponent("NewGoodsList")!
  const _component_NewGoodsInfo = _resolveComponent("NewGoodsInfo")!
  const _component_html_footer = _resolveComponent("html-footer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_NewGoodsList, { newGoodsList: _ctx.newGoodsList }, null, 8, ["newGoodsList"])
        ])
      ])), [
        [_directive_loading, _ctx.newLoading]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityGoodsList.data, (goods, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_NewGoodsInfo, {
                  goods: goods,
                  showBorder: true
                }, null, 8, ["goods"])
              ]))
            }), 256))
          ]),
          (!_ctx.loadingActivityGoods)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.moretext), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, "加载中"))
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _hoisted_14,
    _hoisted_15,
    _hoisted_16,
    _createVNode(_component_html_footer)
  ]))
}